import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './header.css';

const Header = () => {
  let { user, logoutUser } = useContext(AuthContext);

  return (
    <div id="navbar">
      <div id="menu" class="nav-element">
        <p>
          <Link to="/">Home</Link>
        </p>
      </div>
      <div id="site-title" class="nav-element">
        <h2>conNote</h2>
      </div>
      <div id="right-items" class="nav-element">
        {user ? <p onClick={logoutUser}>Logout</p> : <Link to="/login"></Link>}
      </div>
    </div>
  );
};

export default Header;
